import type React from "react";

import {
  HoverCard as ShadcnHoverCard,
  HoverCardTrigger as ShadcnHoverCardTrigger,
  HoverCardContent as ShadcnHoverCardContent,
} from "src/shadcn/components/hover-card";

const HoverCard = (props: React.ComponentProps<typeof ShadcnHoverCard>) => (
  <ShadcnHoverCard {...props} />
);

const HoverCardTrigger = (
  props: React.ComponentProps<typeof ShadcnHoverCardTrigger>
) => <ShadcnHoverCardTrigger {...props} />;

const HoverCardContent = (
  props: React.ComponentProps<typeof ShadcnHoverCardContent>
) => <ShadcnHoverCardContent {...props} />;

export { HoverCard, HoverCardTrigger, HoverCardContent };
